<template>
  <auth>
    <div class="row">
      <div class="col-md-6">
        <div class="social">
          <p>Get started by signing in below</p>
          <ul>
            <li>
              <g-signin-button
                :params="googleSignInParams"
                @success="onSignInSuccess"
                @error="onSignInError"
              >
                <span class="icon" /> Sign in with Google
              </g-signin-button>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-6">
        <div class="auth">
          <div v-html="$error.handle(error)" />
          <div
            v-if="show_verified"
            class="alert alert-success"
          >
            <p>Your account has been verified. You may now log in.</p>
          </div>
          <form
            class="login"
            @submit.prevent="login"
          >
            <br>
            <h4><i class="fa fa-lock" /> Log In</h4>
            <hr>
            <div class="form-group">
              <label>Email</label>
              <input
                v-model="user.email"
                type="text"
                class="form-control"
                placeholder="Enter email"
                autofocus=""
              >
            </div>
            <div class="form-group">
              <label>Password</label>
              <input
                v-model="user.password"
                type="password"
                class="form-control"
              >
            </div>
            <div class="form-group">
              <button class="btn btn-primary">
                Log In
              </button>
            </div>
            <div class="forgot">
              <p>
                <router-link :to="{name: 'register'}">
                  Don't have an account?
                  Register.
                </router-link>
              </p>
              <p>
                <router-link
                  class="link"
                  :to="{name: 'forgot-password'}"
                >
                  Forgot your password?
                </router-link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </auth>
</template>

<script>
    import Auth from "@/components/Auth.vue";

    export default {
        components: {
            Auth
        },

        data() {
            return {
                user: {
                    email: process.env.VUE_GOOGLE_CLIENT_ID,
                    password: '',
                    access_token: ''
                },
                access_token: '',
                error: '',
                show_verified: false,
                googleSignInParams: {
                    client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID
                }
            }
        },
        computed: {
            loggeduser() {
                return this.$store.getters.getAuthUser;
            },
        },

        mounted() {
            const state = this.$route.query.a;

            if (state == 1) {
                this.$router.replace({name: 'login'});
                this.show_verified = 1;
            }
        },
        methods: {
            login() {
                this.error = '';
                this.$axios.post('/api/v1/login', this.user).then(response => {
                    this.navigateLogin(response.data);
                }).catch(err => {
                    this.show_verified = false;
                    this.error = {status: 401, data: {message: 'Invalid Credentials'}};
                    if (err.response.status === 403) {
                        this.error = {status: 401, data: {message: err.response.data}};
                    }
                });
            },
            navigateLogin(data) {
                this.$auth.setToken(data.access_token);
                this.$axios.defaults.headers.Authorization = 'Bearer ' + this.$auth.getToken();
                this.$store.dispatch('setAuthUser', data).then(() => {
                    if (this.loggeduser.requires_password_change) {
                        this.$router.replace({name: 'set-password'});
                        return;
                    }

                    if (this.loggeduser.id_number == null && !this.loggeduser.create_by_admin) {
                        this.$router.replace({name: 'verify.personal'});
                        return;
                    }

                    if (!this.loggeduser.verified_phone && this.loggeduser.id_number !== null) {
                        this.$router.replace({name: 'verify.phone'});
                        return;
                    }

                    if (this.loggeduser.verified_phone) {
                        this.$router.replace({name: 'dashboard'});
                    }
                });

            },
            onSignInSuccess(googleUser) {
                const profile = googleUser.getBasicProfile();
                this.email = profile.getEmail();
                let auth = googleUser.getAuthResponse(true);
                this.access_token = auth.access_token;
                this.googleLogin();
            },
            onSignInError() {
                this.error = {status: 401, data: {message: 'Google sign in failed'}};
            },
            googleLogin() {
                this.$axios.post("api/v1/auth/google", {
                    access_token: this.access_token
                }).then(response => {
                    this.navigateLogin(response.data);
                }).catch(err => {
                    this.error = {status: 401, data: {message: err.response.data}};
                });
            },
        }
    }
</script>
